<template>
  <div class="column-title items-center justify-between">
    <h3 class="font28">{{ title }}</h3>
    <span class="font14" @click="toMore">查看更多 <svg-icon icon-class="arrow-right" color="#AEAEB2" hoverColor="#E2291E" /></span>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    desc: {
      type: String,
      default: "",
    },
    path: {
      type: String,
      default: "/center",
    },
  },
  methods: {
    toMore() {
      this.$router.push({ path: `${this.path}` });
    },
  },
};
</script>

<style lang="less" scoped>
.column-title {
  padding-top: 80px;
  margin-bottom: 30px;
  cursor: pointer;

  h3 {
    font-family: MicrosoftYaHei, MicrosoftYaHei;
    font-weight: bold;
    font-size: 32px;
    color: #2C2C2E;
    line-height: 42px;
    text-align: left;
    font-style: normal;
  }

  span {
    font-family: MicrosoftYaHei;
    font-size: 14px;
    color: #AEAEB2;
    line-height: 19px;
    text-align: left;
    font-style: normal;
    display: flex;
    align-items: center;

    .svg-icon {
      margin-left: 4px;
      width: 16px;
      height: 16px;
    }
  }
  span:hover {
    color: #E2291E;
    .svg-icon{
      color: #E2291E!important;
    }
  }
}

@media screen and (max-width: 768px) {
  .column-title {
    margin: 30px 0 15px;

    h3 {
      font-size: 24px;
      line-height: 1;
    }

    span {
      font-size: 14px;
      line-height: 1.5;
      letter-spacing: 2.1px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/common/column-title.vue